import React from 'react';

import dayjs from 'dayjs';

import { TbArrowLeft, TbArrowRight, TbCalendar, TbCheck } from 'react-icons/tb';

import TextButton from 'components-new/text-button/text-button';

import DropdownMenu from 'components-new/dropdown-menu/dropdown-menu';
import type { DropdownMenuItemType } from 'components-new/dropdown-menu/dropdown-menu-item';
import Icon from 'components-new/icon/icon';

import type { WeekPlannerParams } from 'state/context/organization/OrganizationWeekPlanner/use-week-planner-params';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

interface GridNavitationprops {
  gridParams: WeekPlannerParams;
}

const GridNavigation: React.FC<GridNavitationprops> = ({ gridParams }) => {
  const { selectedWeek, switchToWeekByOffset, weekList, setWeek } = gridParams;

  const onDropdownItemClicked = (clickedWeek: string) => {
    setWeek(clickedWeek);
  };

  const dropdownMenuItems: DropdownMenuItemType[] = weekList.weeks.map(
    (week, index) => {
      const isSelected = weekList.selectedWeekIndex === index;
      const date = dayjs(week, 'DD/MM/YY');

      const obj: DropdownMenuItemType = {
        key: week,
        label: `Week ${date.week()} - ${week}`,
        onClick: () => onDropdownItemClicked(week),
      };
      if (isSelected)
        obj.leadingElement = (
          <Icon icon={TbCheck} size={20} className="text-primary-300" />
        );

      return obj;
    },
  );

  return (
    <div className="flex items-center justify-center w-full sm:w-auto gap-2">
      <TextButton
        variant="secondary"
        leftIconProps={{ icon: TbArrowLeft }}
        onClick={() => switchToWeekByOffset(-1)}
        label={globalLocalize('previous')}
      />
      <DropdownMenu
        menuButton={() => (
          <TextButton
            variant="secondary"
            label={`Week ${selectedWeek[0].week()}`}
            className="w-full"
            labelClassName="whitespace-nowrap mr-1"
            rightIconProps={{ icon: TbCalendar }}
          />
        )}
        items={dropdownMenuItems}
        strategy="fixed"
        menuItemsClassName="max-h-[300px]"
      />

      <TextButton
        variant="secondary"
        rightIconProps={{ icon: TbArrowRight }}
        onClick={() => switchToWeekByOffset(1)}
        label={globalLocalize('next')}
      />
    </div>
  );
};

export default GridNavigation;
